(ns practitest.frontend.forms3.run.navigation
  (:require
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.dropdown :as dropdown]
    [practitest.frontend.components2.spinners :as spinners]
    [practitest.frontend.components2.tooltip :as tooltip]
    [practitest.frontend.forms3.entity-form.header :refer [render-pagination-button]]
    [practitest.frontend.forms3.run.events :as run-events]
    [practitest.frontend.forms3.run.subs :as run-subs]
    [re-frame.core :as re-frame]))

(defn- instance-item [inst disabled?]
  (let [enforce-tooltip (get-translation "run.nav.enforce-run-order-tooltip" "Run Order is Enforced in the project")]
    (if disabled?
      [tooltip/tooltip
       {:placement "right"}
       (fn [hover-props]
         [:div.run-nav-instance-item.disabled hover-props
          [:span.run-nav-instance-label
           (str (get-translation "run.run-instance-of-test" "Run Instance of Test") " #" (:test_display_id inst))]
          [:span.run-nav-instance-separator " | "]
          [:span.run-nav-instance-name (:test_name inst)]])
       enforce-tooltip]
      [:div.run-nav-instance-item
       {:on-click (fn []
                    (mixpanel/track "Run Form Actions" {"Action" "Run Jump Selected"})
                    (re-frame/dispatch [::run-events/navigate-to-instance (:id inst) (:testset_id inst)]))}
       [:span.run-nav-instance-label
        (str (get-translation "run.run-instance-of-test" "Run Instance of Test") " #" (:test_display_id inst))]
       [:span.run-nav-instance-separator " | "]
       [:span.run-nav-instance-name (:test_name inst)]])))

(defn run-navigation [_run-id]
  (let [{:keys [current_position total_count prev_instances next_instances loading? enforce_run_order]}
        @(re-frame/subscribe [::run-subs/navigation-data])
        has-prev?          (seq prev_instances)
        has-next?          (seq next_instances)
        enforce-run-order? enforce_run_order]
    [:div.run-navigation.pagination-control
     [dropdown/dropdown-menu
      (fn [{:keys [toggle!]}]
        [render-pagination-button
         {:disabled? (not has-prev?)
          :href      "#"
          :on-click  (fn [e]
                       (.preventDefault e)
                       (when has-prev?
                         (mixpanel/track "Run Form Actions" {"Action" "Run Navigate Previous Multi"})
                         (toggle!)))
          :label     [:span.run-nav-button-content
                      [:span.run-nav-double-chevron
                       [icons/mux-chevron-left]
                       [:span.run-nav-chevron-overlap [icons/mux-chevron-left]]]
                      (get-translation "run.nav.previous-runs" "Previous Runs")]}])
      {:placement "bottom-start" :shift? true}
      [dropdown/dropdown-menu-body
       (for [[idx inst] (map-indexed vector prev_instances)]
         ^{:key (:id inst)}
         [instance-item inst (and enforce-run-order? (not= idx 0))])]]

     [render-pagination-button
      {:disabled? true
       :href      "#"
       :label     [icons/mux-chevron-left]}]

     [:div.pagination-info-span.with-spinner
      (if loading?
        [spinners/mux-spinner {:size :small}]
        [:span (str current_position " of " total_count)])]

     [render-pagination-button
      {:disabled? true
       :href      "#"
       :label     [icons/mux-chevron-right]}]

     [dropdown/dropdown-menu
      (fn [{:keys [toggle!]}]
        [render-pagination-button
         {:disabled? (not has-next?)
          :href      "#"
          :on-click  (fn [e]
                       (.preventDefault e)
                       (when has-next?
                         (mixpanel/track "Run Form Actions" {"Action" "Run Navigate Next Multi"})
                         (toggle!)))
          :label     [:span.run-nav-button-content
                      (get-translation "run.nav.next-runs" "Next Runs")
                      [:span.run-nav-double-chevron
                       [icons/mux-chevron-right]
                       [:span.run-nav-chevron-overlap [icons/mux-chevron-right]]]]}])
      {:placement "bottom-end" :shift? true}
      [dropdown/dropdown-menu-body
       (for [[idx inst] (map-indexed vector next_instances)]
         ^{:key (:id inst)}
         [instance-item inst (and enforce-run-order? (not= idx 0))])]]]))
